window.readImage = function (event, imageId, width, height) {
    var input = event.target;
    var reader = new FileReader();

    reader.onload = function () {
        var dataURL = reader.result;
        var image = document.getElementById(imageId);

        if (width) {
            image.style.width = width;
        }
        if (height) {
            image.style.height = height;
        }

        image.src = dataURL;
    };

    reader.readAsDataURL(input.files[0]);
};
